/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type AnimationTriggerMetadata, animate, state, style, transition, trigger } from '@angular/animations';

export class AnimationDuration {
    static SLOW = '250ms';
    static BASE = '160ms';
    static FAST = '80ms';
}

export class AnimationCurves {
    static EASE_SLIDE_DOWN = 'cubic-bezier(0.22, 1.00, 0.36, 1.00)';
    static EASE_FADE_OUT = 'cubic-bezier(0.64, 0.00, 0.78, 0.00)';
}

export const SLIDE_DOWN_ANIMATION_SLOW = `${AnimationDuration.SLOW} ${AnimationCurves.EASE_SLIDE_DOWN}`;
export const SLIDE_DOWN_ANIMATION_FAST = `${AnimationDuration.FAST} ${AnimationCurves.EASE_SLIDE_DOWN}`;
export const FADE_OUT_ANIMATION_BASE = `${AnimationDuration.BASE} ${AnimationCurves.EASE_FADE_OUT}`;
export const FADE_OUT_ANIMATION_FAST = `${AnimationDuration.FAST} ${AnimationCurves.EASE_FADE_OUT}`;
/**
 * 下拉动画
 */
export const SlideDownMotion: AnimationTriggerMetadata = trigger('SlideDownMotion', [
    state(
        'void',
        style({
            opacity: 0,
            height: 0,
        }),
    ),
    state(
        'fill',
        style({
            opacity: 1,
            height: 'auto',
        }),
    ),
    state(
        'voidFast',
        style({
            transform: 'translateY(-100%)',
        }),
    ),
    state(
        'fillFast',
        style({
            transform: 'translateY(0%)',
        }),
    ),
    transition('void => fill', animate(SLIDE_DOWN_ANIMATION_SLOW)),
    transition('fill => void', animate(SLIDE_DOWN_ANIMATION_SLOW)),
    transition('voidFast => fillFast', animate(SLIDE_DOWN_ANIMATION_FAST)),
    transition('fillFast => voidFast', animate(SLIDE_DOWN_ANIMATION_FAST)),
]);
/**
 * 渐显动画
 */
export const FadeOutMotion: AnimationTriggerMetadata = trigger('FadeOutMotion', [
    state(
        'hide',
        style({
            opacity: 0,
        }),
    ),
    state(
        'show',
        style({
            opacity: 1,
        }),
    ),
    state(
        'hideFast',
        style({
            opacity: 0,
        }),
    ),
    state(
        'showFast',
        style({
            opacity: 1,
        }),
    ),
    transition('hide => show', animate(FADE_OUT_ANIMATION_BASE)),
    transition('show => hide', animate(FADE_OUT_ANIMATION_BASE)),
    transition('hideFast => showFast', animate(FADE_OUT_ANIMATION_FAST)),
    transition('showFast => hideFast', animate(FADE_OUT_ANIMATION_FAST)),
]);
